import type { FileRoutesByFullPath } from "@/routeTree.gen";
import { currentUserAtom } from "@/store/login";
import { Box, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { useAtomValue } from "jotai";

interface AdminLinkProps {
	to: keyof FileRoutesByFullPath;
	search?: Record<string, string | number | boolean>;
	children: React.ReactNode;
}

const AdminLink = ({ to, search, children }: AdminLinkProps) => {
	const userRole = useAtomValue(currentUserAtom)?.user_role;
	const isAdmin = userRole === "ADMIN";

	if (isAdmin) {
		return (
			<Link to={to} search={search}>
				<Typography
					variant="body2"
					sx={{ ":hover": { color: "primary.main" } }}
				>
					{children}
				</Typography>
			</Link>
		);
	}
	return (
		<Box>
			<Typography variant="body2">{children}</Typography>
		</Box>
	);
};

export default AdminLink;
